import { AnswerModel, interstitialAnswer } from '@/components/decision-tree/hooks';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useGetNavbarHeight } from '@/queries/layout.queries';
import { getInterstitialImageId } from '@/utils';
import { useToast } from '@cmpsr/components';
import { useEffect, useState } from 'react';
import { SectionDividerQuestion } from './types';

export const useSectionDividerController = ({
  saveAnswer,
  data,
  goToNextSurveyItem,
}: {
  saveAnswer: (answer: AnswerModel) => void;
  data: SectionDividerQuestion;
  goToNextSurveyItem: () => void;
}) => {
  const [isAnswered, setIsAnswered] = useState(false);
  const [isLoading, setIsloading] = useState<boolean>(false);
  const toast = useToast();
  const { data: navbarHeight } = useGetNavbarHeight();

  useEffect(() => {
    if (!isAnswered) {
      setIsAnswered(true);
      // For now section dividers behave the same as interstitials
      saveAnswer(interstitialAnswer);
    }
  }, [data.id]);

  const handleNextClick = async () => {
    setIsloading(true);
    try {
      await goToNextSurveyItem();
    } catch (error) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: error,
        status: 'error',
      });
      setIsloading(false);
    }
    setIsloading(false);
  };

  const imageId = getInterstitialImageId(data.resource);

  return { ...data, isLoading, handleNextClick, imageId, navbarHeight };
};
